// Awaryjny limit rozmiaru (2 GiB) — używany dopóki nie wczyta się konfiguracji z BE.
export const DEFAULT_MAX_ATTACHMENT_BYTES = 2 * 1024 * 1024 * 1024;

// Wbudowana lista awaryjna — używana tylko dopóki nie wczyta się konfiguracji z BE
// (/contactForm/config). BE jest źródłem prawdy; to tylko natychmiastowy feedback w UI.
export const DEFAULT_BLOCKED_EXTENSIONS: string[] = [
  // wykonywalne / instalatory
  "exe", "scr", "com", "pif", "msi", "msp", "cpl", "msc", "gadget", "application", "jar",
  // skrypty / powłoka
  "bat", "cmd", "js", "jse", "vbs", "vbe", "wsf", "wsh", "ps1", "psm1", "psc1", "sh", "vb", "ws",
  // aktywna zawartość / HTML / SVG
  "hta", "html", "htm", "xhtml", "mht", "mhtml", "svg",
  // skróty / rejestr / sterowniki
  "lnk", "scf", "url", "reg", "inf", "ins", "isp", "job", "dll", "sys", "drv",
  // makra Office
  "docm", "xlsm", "pptm", "dotm", "xltm", "potm", "xlam", "ppam",
];

// Zwraca pierwsze niedozwolone rozszerzenie (także w środku nazwy — double-extension
// typu "skan.pdf.exe"), albo null jeśli plik jest dozwolony.
// `blocked` to lista z BE; gdy brak/pusta, używamy listy awaryjnej.
export const getBlockedExtension = (
  fileName: string,
  blocked?: string[] | null,
): string | null => {
  if (!fileName) return null;

  const list = blocked && blocked.length ? blocked : DEFAULT_BLOCKED_EXTENSIONS;
  const set = new Set(
    list.map((e) => e.replace(/^\./, "").trim().toLowerCase()),
  );

  const parts = fileName.toLowerCase().split(".");
  for (let i = 1; i < parts.length; i++) {
    const ext = parts[i].trim();
    if (set.has(ext)) return ext;
  }
  return null;
};
